const en = {
	avatar: 'avatar',
	name: 'name',
	eName: '2222',
	cName: '2222',
	phone: '111手机号',
	tips: '1111提示：以下为同步来的信息，仅供参考',
};

export default en;
